import { ReactComponent as LightningIconNormal } from 'assets/UPS/lightning/lightningIconNormal.svg';
import { ReactComponent as LightningIconWarning } from 'assets/UPS/lightning/lightningIconWarning.svg';
import { ReactComponent as LightningIconDanger } from 'assets/UPS/lightning/lightningIconDanger.svg';

import { ReactComponent as SocketIconNormal } from 'assets/UPS/socket/socketIconNormal.svg';
import { ReactComponent as SocketIconWarning } from 'assets/UPS/socket/socketIconWarning.svg';
import { ReactComponent as SocketIconDanger } from 'assets/UPS/socket/socketIconDanger.svg';

import { ReactComponent as SettingsIconNormal } from 'assets/UPS/settings/settingsIconNormal.svg';
import { ReactComponent as SettingsIconWarning } from 'assets/UPS/settings/settingsIconWarning.svg';
import { ReactComponent as SettingsIconDanger } from 'assets/UPS/settings/settingsIconDanger.svg';

import { ReactComponent as FanIconNormal } from 'assets/UPS/fan/fanIconNormal.svg';
import { ReactComponent as FanIconWarning } from 'assets/UPS/fan/fanIconWarning.svg';
import { ReactComponent as FanIconDanger } from 'assets/UPS/fan/fanIconDanger.svg';

import { ReactComponent as BatteryIcon } from 'assets/UPS/batteryNormal.svg';
import { ReactComponent as BatteryIconWarning } from 'assets/UPS/batteryWarning.svg';
import { ReactComponent as BatteryIconDanger } from 'assets/UPS/batteryDanger.svg';

const UpsBlock = ({ type }: { type: 'normal' | 'warning' | 'danger' }) => {
  const colors = {
    normal: '#175E92',
    warning: '#FDBD4D',
    danger: '#FF5233',
  };

  const currentColor = colors[type];

  // Map icon sets by type
  const icons = {
    lightning: {
      normal: LightningIconNormal,
      warning: LightningIconWarning,
      danger: LightningIconDanger,
    },
    socket: {
      normal: SocketIconNormal,
      warning: SocketIconWarning,
      danger: SocketIconDanger,
    },
    settings: {
      normal: SettingsIconNormal,
      warning: SettingsIconWarning,
      danger: SettingsIconDanger,
    },
    fan: {
      normal: FanIconNormal,
      warning: FanIconWarning,
      danger: FanIconDanger,
    },
    battery: {
      normal: BatteryIcon,
      warning: BatteryIconWarning,
      danger: BatteryIconDanger,
    }
  };

  // Pick correct icon component for current type
  const LightningIcon = icons.lightning[type];
  const SocketIcon = icons.socket[type];
  const SettingsIcon = icons.settings[type];
  const FanIcon = icons.fan[type];
  const Battery = icons.battery[type];

  return (
    <div
      className="rounded-lg w-full z-20"
      style={{
        border: `1px solid ${currentColor}`,
        backgroundColor: `${currentColor}26`, // ~15% opacity
      }}
    >
      <div>
        <div className="p-3 2xl:p-2 px-4">
          <h3 className="w-full text-center my-1 text-md 2xl:text-xl font-bold">
            String1- 14 Blocks
          </h3>
          <div
            className="grid grid-cols-2 grid-rows-2 w-full p-1 2xl:p-2 rounded-lg"
            style={{
              backgroundColor: `${currentColor}66`, // ~40% opacity
              border: `1px solid ${currentColor}`,
            }}
          >
            <div className="flex items-center justify-between flex-col py-2">
              <LightningIcon />
              <p className="text-center">Voltage 12.2v</p>
            </div>
            <div className="flex items-center justify-between flex-col py-2">
              <SocketIcon />
              <p className="text-center">Current 23A</p>
            </div>
            <div className="flex items-center justify-between flex-col py-2">
              <SettingsIcon />
              <p className="text-center">Power 123WT</p>
            </div>
            <div className="flex flex-col items-center justify-between py-2">
              <FanIcon />
              <p className="text-center">Avg Temp 34 c</p>
            </div>
          </div>
        </div>

        {/* Dividers */}
        <div className="w-full h-8 2xl:h-8 2xl:h-10 grid grid-cols-3" style={{ borderTop: `1px solid ${currentColor}` }} >
          <div
            style={{
              borderRight: `1px solid ${currentColor}`,
            }}
            className='flex items-center justify-center'
          ><Battery /></div>
          <div
            style={{
              borderRight: `1px solid ${currentColor}`,
            }}
            className='flex items-center justify-center'
          ><Battery /></div>
          <div className='flex items-center justify-center'><Battery /></div>
        </div>
        <div className="w-full h-8 2xl:h-10 grid grid-cols-3" style={{ borderTop: `1px solid ${currentColor}` }} >
          <div
            style={{
              borderRight: `1px solid ${currentColor}`,
            }}
            className='flex items-center justify-center'
          ><Battery /></div>
          <div
            style={{
              borderRight: `1px solid ${currentColor}`,
            }}
            className='flex items-center justify-center'
          ><Battery /></div>
          <div className='flex items-center justify-center'><Battery /></div>
        </div>
        <div className="w-full h-8 2xl:h-10 grid grid-cols-3" style={{ borderTop: `1px solid ${currentColor}` }} >
          <div
            style={{
              borderRight: `1px solid ${currentColor}`,
            }}
            className='flex items-center justify-center'
          ><Battery /></div>
          <div
            style={{
              borderRight: `1px solid ${currentColor}`,
            }}
            className='flex items-center justify-center'
          ><Battery /></div>
          <div className='flex items-center justify-center'><Battery /></div>
        </div>
      </div>
    </div>
  );
};

export default UpsBlock;
